import React from 'react';

// import { Container } from './styles';

const NoMatchPage = () => {
  return <h1>404 Page</h1>;
};

export default NoMatchPage;
